import KmxSearchStroked from '@kmx/mui-icons/KmxSearchStroked';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Carousel from './Carousel';
import { MuiSkeletonVehicleTile } from './MUISkeletonVehicleTile';

export const SearchedPlaceholderCarousel = () => (
    <div className="home-base-hero--tab-placeholder home-base-hero--searched-tab-placeholder carousel-container">
        <ul className="tab-placeholder--list">
            <Carousel
                name="searched-auth-tab-placeholder"
                nextFocus="#budget-calculator-section"
                ariaLabel="No Recent Searches"
                leftAligned={false}
            >
                <li className="tab-placeholder--list-item carousel__slide" key="searched-auth-tab-placeholder-tile-1">
                    <Paper
                        sx={{
                            padding: { xs: 4, lg: 5 },
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                        className="carousel-slide-item"
                    >
                        <Stack gap={3}>
                            <Stack>
                                <Box>
                                    <KmxSearchStroked sx={{ fontSize: '56px' }} />
                                </Box>
                                <Typography variant="h5">Need help getting started?</Typography>
                            </Stack>
                            <Button color="primary" variant="outlined" size="medium" href="/cars">
                                Start here
                            </Button>
                        </Stack>
                    </Paper>
                </li>
                <li
                    className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                    key="searched-auth-tab-placeholder-tile-2"
                >
                    <MuiSkeletonVehicleTile />
                </li>
                <li
                    className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                    key="searched-auth-tab-placeholder-tile-3"
                >
                    <MuiSkeletonVehicleTile />
                </li>
                <li
                    className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                    key="searched-auth-tab-placeholder-tile-4"
                >
                    <MuiSkeletonVehicleTile />
                </li>
            </Carousel>
        </ul>
    </div>
);
